import React, { Suspense, useEffect, useRef, useState } from "react";
import DataLoader from "../../components/FinalMolGrid/ui/dataLoader/DataLoader";
import FormCreator from "../../components/forms/FormCreator";
import Buttons from "../../components/ui/button/Buttons";
import FinalMolGrid from "../../components/FinalMolGrid/FinalMolGrid";
import { PaymentReconciliationRecord } from "./data/PaymentReconciliation.Data";
import { PaymentReconciliationRecordList } from "./data/PaymentReconciliationRecordList.Data";
import CenterModel from "../../components/ui/centerModel/CenterModel";
import {
  useGetPaymentReconcilationListMutation,
  useLazyGetAllDropDownsForTaskListQuery,
} from "../../app/services/PaymentReconciliation/PaymentReconciliationApi";
import { setAllDropDownFieldsBatch } from "../../utils/FormFields/FieldsSetting/SetFieldSetting";
import { paginationObj } from "../../utils/Constants";
import EditPaymentReconciliation from "./components/EditPaymentReconciliation";
import SwalAlert from "../../services/swalService/SwalService";
import { useLazyDeletePaymentReconcilationByIdQuery } from "../../app/services/PaymentReconciliation/PaymentReconciliationApi";
import AddRecordsModel from "./components/AddRecordsModel";
import { getAuditContext } from "../../lib/authenticationLibrary";

const PaymentReconciliation = () => {
  const paymentReconciliationRef = useRef();
  const editPaymentReconsiationRef = useRef();
  const { confirm, success, error } = SwalAlert();
  const audit = getAuditContext();

  /* State */
  const [paymentReconciliationRecord, setPaymentReconciliationRecord] = useState(PaymentReconciliationRecord);
  const [isModalOpenAddRecord, setIsModalOpenAddRecord] = useState(false);
  const [dataSource, setDataSource] = useState();
  const [pagination, setPagination] = useState({
    ...paginationObj,
    InvoiceNo: null,
    PaymentProofStatusId: null,
    filterStartDate: null,
    filterEndDate : null,
    PaymentCategoryId: null,
  });
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const [paymentProofDetails, setPaymentProofDetails] = useState({
    membershipPaymentId: null,
    paymentProofId: null,
    ipasMemberId: null,
    taskListId: null,
  });

  const taskListDropDowns = [
    { dropdownName: "PaymentProofStatus", fieldId: "status" },
    { dropdownName: "MembershipPaymentType", fieldId: "paymentCategory" },
  ];

  // API Calls
  const [getTaskListDropDown, {
    isLoading: taskListDropDownIsLoading,
    isSuccess: taskListDropDownIsSuccess,
    data: taskListDropDownData },] = useLazyGetAllDropDownsForTaskListQuery();

  const [getPaymentReconcilationList, {
    isLoading: reconsilationListIsLoading,
    isSuccess: reconsilationListIsSuccess,
    data: reconciliationListData },] = useGetPaymentReconcilationListMutation();

  const [deletePaymentReconcilationById, {
    isLoading: isDeleteMemberLoading,
    isSuccess: isDeleteMemberSuccess,
    data: deleteMemberResponse, },] = useLazyDeletePaymentReconcilationByIdQuery();
  // useEffects
  useEffect(() => {
    if (!taskListDropDownIsLoading && taskListDropDownIsSuccess && taskListDropDownData) {
      setAllDropDownFieldsBatch(PaymentReconciliationRecord, taskListDropDowns, taskListDropDownData);
    }
  }, [taskListDropDownIsLoading, taskListDropDownIsSuccess, taskListDropDownData,]);

  useEffect(() => {
    if (!reconsilationListIsLoading && reconciliationListData && reconsilationListIsSuccess) {
      setDataSource(reconciliationListData.itemList);
      setPagination((prev) => {
        return { ...prev, totalCount: reconciliationListData.totalCount };
      });
    }
  }, [reconsilationListIsLoading, reconciliationListData, reconsilationListIsSuccess]);

  useEffect(() => {
    if (!isDeleteMemberLoading && isDeleteMemberSuccess && deleteMemberResponse) {
      if (!deleteMemberResponse.hasError) {
        success("Record Deleted Successfully.");
        getRecordList(pagination);
      } else {
        error(deleteMemberResponse.errorMessage);
      }
    }
  }, [isDeleteMemberLoading, isDeleteMemberSuccess, deleteMemberResponse]);

  useEffect(() => {
    getTaskListDropDown();
    getRecordList(pagination);
  }, []);

  // Functions
  const getRecordList = (data) => {
    getPaymentReconcilationList(data);
  };

  const handlePageChange = (page) => {
    const { pageNumber, pageSize } = page;
    getRecordList({ ...pagination, pageSize: pageSize, pageNo: pageNumber });
  };

  const searchClick = () => {
    let formData = paymentReconciliationRef?.current?.getFormData();
    debugger
    let request = {
      ...paginationObj,
      InvoiceNo: formData?.invoiceNo || null,
      PaymentProofStatusId: formData?.status?.value || null,
      FilterStartDate: formData?.filterStartDate || null,
      FilterEndDate: formData?.filterEndDate || null,
      PaymentCategoryId: formData?.paymentCategory?.value || null,
    };
    setPagination((prev) => {
      return { ...prev, ...request };
    });
    getRecordList(request);
  };

  const handleEditClick = (data) => {
    if (!data) return;
    const { paymentProofId, membershipPaymentId, ipasMemberId, taskListId, bookingId, } = data;
    setPaymentProofDetails({
      ...paymentProofDetails,
      membershipPaymentId: membershipPaymentId,
      bookingId: bookingId,
      paymentProofId: paymentProofId,
      ipasMemberId: ipasMemberId,
      taskListId: taskListId,
    });
    openModalEditTaskList();
  };
  const handleDeleteClick = (data) => {

    confirm("Delete?", "Are you sure you want to Delete?", "Delete", "Cancel").then((confirmed) => {
      if (confirmed) {
        // const request = {
        //   id: data?.taskListId !== null ? data?.taskListId : 0,
        //   id2: data?.bookingId !== null ? data?.bookingId : 0,
        // };
        let id = data?.paymentProofId;
        const request = {id: data?.paymentProofId,
                         id2: audit.adminUserId,
                         id3: audit.appId};
        deletePaymentReconcilationById(request);
      }
    });
  };

  const openModelAddRecords = () => {
    setIsModalOpenAddRecord(!isModalOpenAddRecord);
  }

  const actionHandler = {
    EDIT: handleEditClick,
    DELETE: handleDeleteClick,
  };

  const openModalEditTaskList = () => {
    setIsEditModalOpen(!isEditModalOpen);
  };

  const getReconsilationRecordsAfterAction = () => {
    getRecordList(pagination);
  };

  const handleClearClick = () => {
    const formData = { ...paymentReconciliationRecord };
    formData.initialState = {
      invoiceNo: null,
      status: null,
      filterStartDate: null,
      filterEndDate: null,
      paymentCategory: null,
    }
    let request = {
      ...paginationObj,
      InvoiceNo: null,
      PaymentProofStatusId: null,
      FilterStartDate: null,
      FilterEndDate: null,
      PaymentCategoryId: null,
    };
    setPagination((prev) => {
      return { ...prev, ...request };
    });
    getRecordList(request);
    setPaymentReconciliationRecord(formData);
  }
  return (
    <div>
      <div className="membership-application">
        <div className="form-card mt-4">
          <Suspense fallback={<DataLoader />}>
            {taskListDropDownIsLoading ? (
              <DataLoader />
            ) : (
              <>
                <div className="">
                  <FormCreator
                    config={paymentReconciliationRecord}
                    ref={paymentReconciliationRef}
                    key={false}
                  />
                  <div className="btn-sec form-btn-minus">
                    <Buttons
                      onClick={handleClearClick}
                      buttonText={"Clear"}
                      buttonTypeClassName="back-btn btn mt-auto mr-4 text-light"
                      isLoading={false}
                    />
                    <Buttons
                      onClick={searchClick}
                      buttonText={"Search"}
                      buttonTypeClassName="theme-btn btn mt-auto"
                      isLoading={false}
                    />
                  </div>
                </div>
                <div className="payment-btn-part mt-5">
                  <h5 className="mt-auto mb-0">Total Count: {pagination?.totalCount || 0}</h5>
                  <div className="btn-sec ml-auto">
                    <Buttons
                      onClick={openModelAddRecords}
                      buttonText={"Add Records"}
                      buttonTypeClassName="theme-btn btn mt-auto "
                      isLoading={false}
                    />
                  </div>
                </div>
              </>
            )}
          </Suspense>
          <div className="table-100  mt-2 paymentapproval-table">
            <FinalMolGrid
              ref={editPaymentReconsiationRef}
              configuration={PaymentReconciliationRecordList}
              dataSource={dataSource}
              isLoading={reconsilationListIsLoading}
              allowPagination={true}
              pagination={pagination}
              onActionChange={actionHandler}
              onPageChange={handlePageChange}
            />
          </div>
        </div>
      </div>

      {isEditModalOpen && (
        <CenterModel
          modelTitle={"Payment Reconciliation"}
          show={"test"}
          handleClose={openModalEditTaskList}
          onUpload={openModalEditTaskList}
        >
          <EditPaymentReconciliation
            paymentProofDetails={paymentProofDetails}
            taskListDropDownData={taskListDropDownData}
            closeModel={openModalEditTaskList}
            getReconsilationRecors={getReconsilationRecordsAfterAction}
          />
        </CenterModel>
      )}

      {isModalOpenAddRecord && <CenterModel
        modelTitle={'Outstanding Invoices List'}
        show={"test"}
        handleClose={openModelAddRecords}
        onUpload={openModelAddRecords}
      >
        <AddRecordsModel />
      </CenterModel>
      }
    </div>
  );
};

export default PaymentReconciliation;
